import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_part_dealers`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_part_dealers/${id}`, options)
    .then(response => {
      let part_dealers = jsona.deserialize(response.data);
      delete part_dealers.links;
      return part_dealers;
    });
}

function add(part_dealers) {
  
  console.log(part_dealers);
  const payload = jsona.serialize({
    stuff: part_dealers,
    includeNames: null
  });
  console.log(payload);
  console.log("jajajajaja");
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_part_dealers`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(part_dealers) {
  const payload = jsona.serialize({
    stuff: part_dealers,
    includeNames: []
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_part_dealers/${part_dealers.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_part_dealers/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_part_dealers/last/no`, options)
    .then(response => {
      return response.data;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no
};

